import { Box, FormControlLabel, Switch } from "@mui/material";
import { useState } from "react";
import UpgradeDialog from "../Dialogs/UpgradeDialog";
import UpgradeDialogV2 from "../Dialogs/UpgradeDialogV2";

const trackPerformanceUpgradeDialog = {
    title: "Unlock Advanced QR Code Analytics",
    subtitle: "Track every scan, analyze user behavior, and modify your QR codes anytime.",
    features: [
      {
        primary: "Real-time QR Code Tracking",
        secondary: "Monitor every scan with detailed insights, including location, device, and timestamp."
      },
      {
        primary: "Modify QR Code Destinations Anytime",
        secondary: "Change where your QR code points without needing to reprint."
      },
      {
        primary: "Advanced Analytics Dashboard",
        secondary: "View trends, scan frequency, and audience engagement over time."
      },
      {
        primary: "Export Analytics Data",
        secondary: "Download scan data reports for further analysis and optimization."
      },
      {
        primary: "Custom Alerts & Notifications",
        secondary: "Get notified when your QR codes reach engagement milestones."
      }
    ]
  };
  

  
const TrackPerformanceSwitch = () => {
    const [openUpgradeDialog, setOpenUpgradeDialog] = useState(false);
    const [isSwitchOn, setIsSwitchOn] = useState(false);

    const onSwitch = () => {
        setOpenUpgradeDialog(true);
        setIsSwitchOn(false); 
    };

    return(
        <>
            <Box>
                <FormControlLabel
                    control={
                        <Switch
                            sx={{ color: "#000" }}
                            checked={isSwitchOn}
                            onChange={onSwitch}
                        />
                    }
                    label="Track Performance & Modify Anytime"
                />
            </Box>
            <UpgradeDialogV2 
                open={openUpgradeDialog} 
                onClose={() => setOpenUpgradeDialog(false)} 
                title={trackPerformanceUpgradeDialog.title}
                subtitle={trackPerformanceUpgradeDialog.subtitle}
                requestedFeature="qr"
            />

        </>
    )
}

export default TrackPerformanceSwitch;